import { TopNavWrapper } from "components/Layouts/TopNavWrapper"
import { BackButton } from "components/Common/BackButton"
import ChevronLeftBtn from "components/Icons/ChevronLeftBtn"
import styled from "styled-components"
import { LogMealType } from "model/food/types/base.types"
import FoolDetailsMealTypeSelection from "components/mealTypeSelection/FoodDetailsMealTypeSelection"

export const StyledMealDetailsHeader = styled.div`
  position: absolute;
  height: 44px;
  width: 100%;
  display: flex;
  align-items: center;
  z-index: 10;
  justify-content: space-between;
  padding: 0 var(--app-horizontal-padding);

  svg {
    cursor: pointer;
  }
`

interface IMealDetailsHeaderProps {
  onBack: () => void
  mealType?: LogMealType
  onMealTypeChange: (mealType?: LogMealType) => void
}

const MealDetailsHeader = ({
  onBack,
  mealType,
  onMealTypeChange,
}: IMealDetailsHeaderProps) => (
  <TopNavWrapper>
    <StyledMealDetailsHeader>
      <BackButton onClick={onBack}>
        <ChevronLeftBtn />
      </BackButton>
      <FoolDetailsMealTypeSelection
        value={mealType}
        onChange={onMealTypeChange}
      />
      <div style={{ width: 24, height: 24 }} />
    </StyledMealDetailsHeader>
  </TopNavWrapper>
)

export default MealDetailsHeader
